import qs from 'qs';
import { network } from 'services/network';

export const getAuditedCard = (params: { id?: number; versionId?: number; isVirtual?: boolean }) => {
    const queryString = qs.stringify(
        { cardId: params.id, versionId: params.versionId, isVirtual: params.isVirtual },
        { addQueryPrefix: true, skipNulls: true },
    );
    const url = `api/bo/getAuditedCard${queryString}`;

    return network.get(url).then((response) => {
        return response.data;
    });
};
